// extracted by mini-css-extract-plugin
export default {"content":"Societies_content__Im6mP","realContent":"Societies_realContent__1bzer"};